import { Playground } from 'docz';
import Menu from "../../../../../src/components/Menu/index";
import * as React from 'react';
export default {
  Playground,
  Menu,
  React
};